import React from 'react'
import withView from '../../../cmn/docAutomation/withView';
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormLabel from '../../../../library/form/components/FormLabel'
import FormTitle from '../../../../library/form/components/FormTitle';
import DocFormReview from "../../../cmn/docReviewStatus/DocFormReview";
import FormWrapper from "../../../../library/form/components/FormWrapper";
import { UiView, UiViewHeading, UiTitle, UiViewContent } from "../../../../library/layout/Index";
import FormAMCStatus from '../../../../library/form/components/FormAMCStatus';
import SarasTrans from '../../../../library/notifications/SarasTrans';

const TaskHeader2 = (props) => {
    const { formObject, viewData } = props;
    
    if(!viewData)
        return(null);

    return (
            <UiView>
                <UiViewHeading>
                    <UiTitle>
                        <FormTitle formObject={formObject} value='Task Detail' />
                    </UiTitle>
                </UiViewHeading>
                <UiViewContent>
                    <div className="uiGridCol">
                        <ul>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "requestedBy" }} value="Requested By" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "requestedBy" }} className="uiVal" />
                            </li>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "taskDate" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "taskDate" }} value="Task Date" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "taskDate" }} className="uiVal uiHighlightKey" />
                            </FormWrapper>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "startDate" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "startDate" }} value="Start Date" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "startDate" }} className="uiVal uiHighlightKey" />
                            </FormWrapper>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "visitDate" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "visitDate" }} value="Visit Scheduled On" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "visitDate" }} className="uiVal uiHighlightKey" />
                            </FormWrapper>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "status" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "status" }} value="Status" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "status" }} className="uiVal uiHighlightBlue" />
                            </FormWrapper>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "statusSince" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "statusSince" }} value="Since" />
                                </span>
                                <FormROValue formObject={formObject} rowKey="" action={{ paramName: "statusSince" }} className="uiVal" />&nbsp;
                                <FormROValue formObject={formObject} rowKey="" action={{ paramName: "taskStatusBy" }} className="uiVal" />
                            </FormWrapper>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "amcStatusContainer" }} >
                                <div className='uiFlexBox'>
                                    <span className="uiLbl">
                                        <SarasTrans value="AMC Status" />
                                    </span>
                                    <FormAMCStatus formObject={formObject} rowKey="" action={{ paramName: "amcStatus" }}/>
                                </div>
                            </FormWrapper>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "wfStatusContainer" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "" }} value="Review Status" />
                                </span>
                                <DocFormReview formObject={formObject} />
                            </FormWrapper>
                            <FormWrapper customWrapper="li" formObject={formObject} rowKey="" action={{ paramName: "address" }} >
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "address" }} value="Visit Address" />
                                </span>
                                <FormROValue formObject={formObject} rowKey="" action={{ paramName: "address" }} className="uiVal" />
                            </FormWrapper>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "createdBy" }} value="Created By" />
                                </span>
                                <FormROValue formObject={formObject} rowKey="" action={{ paramName: "createdBy" }} className="uiVal" />
                            </li>
                        </ul>
                    </div>
                </UiViewContent>
            </UiView>
    )
}

export default withView(TaskHeader2, "taskDetail", "")